import Simakirana1 from "./simakirana (1).webp";
import Simakirana2 from "./simakirana (2).webp";

const simakirana = [Simakirana1, Simakirana2];

export default simakirana;
